<template>
  <div class="padre">
    <div
      style="minWidth:50%"
      :style="[!tamanoHc? {width:'100%'}:{width: 
'75%'}]"
      id="historiaClinicaDeslizar"
    >
      <formulario-overlay
        :verComponente="verComponente"
        @overlay="cerrarOverlay"
        @cerrarOverlay="cerrarOverlaySinActualizar"
        v-if="overlay"
        :paciente="pc_paciente"
        :banderaSubirArchivo="banderaSubirArchivo"
        :datosMarcacionesPrograma="datosMarcacionesPrograma"
      ></formulario-overlay>
      <header-nav></header-nav>
      <div id="main">
        <div id="Grid" class="elevation-2">
          <div
            class="ColumnaUno"
            id="contenedorChatBox"
            :class="{'reducirItem3':!chatAbierto}"
          >
            <!-- Bloque con informacion basica del paciente -->
            <!-- Bloque del chatbox -->
            <div class="item3">
              <chat-box-nuevo @cerrarChat="cerrarChat" :chatAbierto="chatAbierto"></chat-box-nuevo>
            </div>
          </div>
          <div
            id="ColumnaDos"
            class="resizeColumnaDos"
            style="minWidth:50%;width:100%;"
            :class="{'expandirItem2':!chatAbierto}"
          >
            <!-- Bloque donde se cargan los modulos variables -->
            <div class="item2">
              <div
                v-bind:class="[{item1Comprimido:!banderaExpandir}, {item1Expandido:banderaExpandir}]"
              >
                <div
                  id="IzquierdaPaciente"
                  v-if="matriz_info_paciente.length!=0 && getCedulaPaciente"
                >
                  <div class="informacionCompleta">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <img
                          v-on="on"
                          @click="verOverlayFormularioInformacionGeneral()"
                          class="imagenPerfil perfil-info-general"
                          src="https://firebasestorage.googleapis.com/v0/b/neumomeddesarrollo.appspot.com/o/Perfil-sin-foto.png?alt=media&token=acf1ad0c-1ef6-47e6-a55b-83f24cec0b84"
                        />
                      </template>
                      <span>Ver información general</span>
                    </v-tooltip>
                    <div class="nombreCompleto">
                      <div v-for="(datos,index) in matriz_info_paciente" :key="index">
                        <div v-if="datos.visible">
                          <div v-if="datos.nombre=='Nombre paciente' || datos.nombre=='Apellido'">
                            <h3 class="nombrePaciente">
                              <span>{{datos.valor}}</span>
                            </h3>
                          </div>
                          <transition name="fade" v-else-if="banderaExpandir">
                            <transition name="fade">
                              <div
                                class="textoDatosPaciente"
                                v-if="datos.nombre=='Edad' && datos.nombre!='Nombre' || datos.nombre!='Apellido'"
                              >
                                <h5 id="Principal">
                                  <span class="colorDatosPaciente">{{datos.nombre}}:</span>
                                  {{ datos.valor }} {{ datos.unidad }}
                                </h5>
                              </div>
                            </transition>
                          </transition>
                          <!-- Detalles del paciente -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="IzquierdaPaciente" v-else>
                  <div
                    class="informacionCompleta"
                    v-bind:class="{'bordeGestion':cambiaPanelLateral=='9'}"
                  >
                    <img
                      v-bind:class="{'invisible':cambiaPanelLateral=='9'}"
                      class="imagenPerfil"
                      src="https://firebasestorage.googleapis.com/v0/b/neumomeddesarrollo.appspot.com/o/Neumocabeza.png?alt=media&token=e0fe607b-e501-4158-8ba4-e25bac5cf35d"
                    />
                    <h3
                      v-bind:class="{'invisible':cambiaPanelLateral=='9'}"
                      class="nombreBot"
                    >Doctor Neumo</h3>
                    <!-- <v-icon   v-if="cambiaPanelLateral=='9'"  class="imagenPerfil imagenGestion"> mdi-chart-bell-curve-cumulative </v-icon> -->
                    <div v-if="cambiaPanelLateral=='9'" class="contenedorImagenGestion elevation-4">
                      <icono
                        class="imagenGestion"
                        nombreIcono="icono Grafica"
                        :value="iconoGrafica"
                      />
                    </div>
                    <h3 v-if="cambiaPanelLateral=='9'" class="nombreBot">Gestión</h3>
                  </div>
                </div>
                <div class="flechaExpandir" v-if="matriz_info_paciente.length">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <!-- <button class="botonCircularPequeno elevation-2" @click="verOverlayHC('verHistoriaClinica')" v-on="on">
                          <Icono class="agenda" nombreIcono="Ver encuentro" :value="verEncuentro"/>
                      </button>-->
                      <button
                        v-show="$route.name=='TimeLine'?false:true"
                        class="botonCircularPequeno elevation-2"
                        @click="verTimeLine()"
                        v-on="on"
                      >
                        <Icono class="agenda" nombreIcono="Ver encuentro" :value="verEncuentro" />
                      </button>
                    </template>
                    <span>Ver encuentros</span>
                  </v-tooltip>
                  <!-- <v-tooltip bottom v-if="cambiaPanelLateral!='6'">
                      <template v-slot:activator="{ on }">
                        <button class="botonCircularPequeno elevation-2" v-on="on"  @click="consultarMarcacionesProgramas()">
                          <Icono class="agenda contenidoMarcaciones" nombreIcono="Marcaciones programa" :value="marcacionesPrograma"/>
                        </button>
                      </template>
                      <span>Marcaciones programa</span>
                  </v-tooltip>-->
                  <button class="botonCircularPequeno" @click="expandirPanel()">
                    <Icono
                      :value="banderaExpandir===false ? flechaAbajo : flechaArriba"
                      class="iconoFlecha"
                    />
                  </button>
                </div>
              </div>
              <div
                v-bind:class="[{item2Comprimido:!banderaExpandir}, {item2Expandido:banderaExpandir}]"
                class="scrollbar"
              >
                <div
                  v-if="getMomentosEncuentro && $store.getters.cambiaPanelLateral=='5'"
                  class="panelLateral"
                >
                  <div
                    v-show="getMomentosEncuentro.length>2 && banderaCheckpoint"
                    v-bind:style="[index10==getMomentosEncuentro.length -1? {} : {width:'12%'}]"
                    v-for="(momento, index10) in getMomentosEncuentro"
                    :key="index10"
                    @mouseenter="asignarPosicionPopUP(index10,momento.momento)"
                    @mouseleave="cerrarPopUp()"
                    @click="enviaMomentoChat(momento.nombre, momento.momento)"
                    :id="'avatar'+ index10"
                    class="animated fadeInDown divAvatar"
                  >
                    <v-tooltip top v-if="index10==getMomentoActual-1">
                      <template v-slot:activator="{ on }">
                        <v-avatar size="62" class="md-large md-elevation-4 momentoActual" v-on="on">
                          <Icono
                            class="momentoAct momentoActIcono"
                            :value="momento.icon"
                            alt="Avatar"
                          />
                        </v-avatar>
                      </template>
                      <span>{{momento.nombre}}</span>
                    </v-tooltip>
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on }">
                        <v-avatar
                          class="md-elevation-2 momentos"
                          v-bind:style="[index10>getMomentoActual-1? {color:'#c4cacf'} : {}]"
                          v-on="on"
                        >
                          <Icono
                            v-bind:style="[index10<=getMomentoActual-1? {color:'#33ccff'} : {}]"
                            class="momento"
                            :value="momento.icon"
                            alt="Avatar"
                          />
                        </v-avatar>
                      </template>
                      <span>{{momento.nombre}}</span>
                    </v-tooltip>
                    <hr v-if="index10!=getMomentosEncuentro.length -1" id="lineaStep" />
                  </div>
                  <pop-up
                    v-show="mostrarPopUp"
                    id="popUp"
                    v-bind:style="{top:topPopUp, left:leftPopUp}"
                    :informacionFormulariosLlenos="informacionFormulariosLlenos"
                  ></pop-up>
                </div>
                <div class="divTextoGenerado" v-if="getTextoGenerado!=null">
                  <label>Resumen de consulta</label>
                  <div class="contenedorCopiar">
                    <v-textarea
                      solo
                      rows="8"
                      v-model="textoGenerado"
                      class="textArea"
                      :value="getTextoGenerado"
                    ></v-textarea>
                  </div>
                  <div class="contenedorCopiar">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn id class="botonTextoGenerado" @click="actualizarResumen()" v-on="on">
                          <v-icon>save</v-icon>
                        </v-btn>
                      </template>
                      <span>Guardar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="btnCopiar botonTextoGenerado"
                          @click="copiarAlPortapapeles('textoGenerado')"
                          v-on="on"
                        >
                          <v-icon class="iconoBotonCopiar">{{iconoCopiar}}</v-icon>
                        </v-btn>
                      </template>
                      <span>Copiar</span>
                    </v-tooltip>
                  </div>
                </div>
                <control-panel v-if="cambiaPanelLateral=='1'"></control-panel>
                <mensajes v-else-if="cambiaPanelLateral=='2'"></mensajes>
                <agenda v-else-if="cambiaPanelLateral=='3'"></agenda>
                <panel-auxiliar v-else-if="cambiaPanelLateral=='5'" :texto_introductorio="texto_introductorio"></panel-auxiliar>
                <ver-historia-clinica v-else-if="cambiaPanelLateral=='6'"></ver-historia-clinica>
                <agendamiento v-else-if="cambiaPanelLateral=='7'"></agendamiento>
                <seguimiento-paciente v-else-if="cambiaPanelLateral=='8'"></seguimiento-paciente>
                <grafica-gestion
                  :valorSeleccionadoDialogo="valorSeleccionadoDialogo"
                  v-else-if="cambiaPanelLateral=='9'"
                ></grafica-gestion>
                <confirmar-cita :valorSeleccionadoDialogo="valorSeleccionadoDialogo" v-if="cambiaPanelLateral=='10'" />
                <agenda-doctor v-if="cambiaPanelLateral=='11'" />
                <administracion-horarios v-if="cambiaPanelLateral=='12'" />
                <gestion-ordenes v-if="cambiaPanelLateral=='13'"></gestion-ordenes>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        class="botonCircularMediano elevation-2"
        :ripple="false"
        v-if="!chatAbierto"
        @click="abrirChat()"
      >
        <Icono :value="iconoBot" />
      </button>
      <!-- <v-btn fab class="botonAbrirChat" :ripple="false" v-if="!chatAbierto" @click="chatAbierto=true">
      <Icono :value="iconoBot" height="2.083vw" width="2.083vw" />
      </v-btn>-->
    </div>
    <v-expand-x-transition>
      <router-view
        @cambioTamano="cambiarTamanoHC()"
        transition="slide-x-transition"
        @tamanoHc="tamanoHc=false"
        @abrirChat="chatAbierto=true"
        @verEncuentro="verOverlayHC('verHistoriaClinica')"
      ></router-view>
    </v-expand-x-transition>
    <mensajes-nuevo v-if="variablesInforGeneral.length > 0 && getCedulaPaciente" :dataPacient ='{}' :infoPatient="variablesInforGeneral"/>
  </div>
</template>
<script>
import axios from "../apiService/config/axios.js";
import HeaderNav from "../components/HeaderNav/HeaderNav";
import { serverBus } from "../main";
import ControlPanel from "../components/ControlPanel";
import InformacionPaciente from "../components/InformacionPaciente";
import { setTimeout } from "timers";
import Mensajes from "../components/Mensajes";
import Agenda from "../components/Agenda";
import Agendamiento from "../components/Agendamiento/Agendamiento";
import Vue from "vue";
import Progress from "vue-multiple-progress";
import VueCarousel from "vue-carousel";
import { Carousel, Slide } from "vue-carousel";
import PanelAuxiliar from "../components/PanelAuxiliar";
import verHistoriaClinica from "../components/verHistoriaClinica/verHistoriaClinica";
import metodos_comunes from "../js/metodos_comunes";
import variableEntorno from "../../static/config.json";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import ChatBoxNuevo from "../components/Chatbox/ChatboxNuevo/ChatboxNuevo";
import PopUp from "../components/PopUp/popUp";
import "babel-polyfill";
import { consultarInformacionMomentoLlenos } from "../apiService/request/CrudEncuentro.js";
import TarjetasFormulariosMomentos from "../components/TarjetasFormulariosMomentos/TarjetasFormulariosMomentos";
import SeguimientoPaciente from "../components/Seguimiento/SeguimientoPaciente/SeguimientoPaciente";
import { log } from "util";
import Icono from "../components/Icono/Icono";
import graficaGestion from "../components/Gestion/graficaGestion/graficaGestion";
import ConfirmarCita from "../components/ConfirmarCita/ConfirmarCita";
import AgendaDoctor from "../components/AgendaDoctor/AgendaDoctor";
import Notificaciones from "../components/Notificaciones/Notificaciones";
import {
  consultarTipoEncuentroSeguimiento,
  crearCuestionario,
  consultarEstructuraCuestionarioPorId,
  consultarMarcaciones,
  consultarMarcacionesProgramasPaciente
} from "../apiService/request/CrudSeguimiento";
import { ordenesAutomaticas } from "../apiService/request/CrudOrdenes";
// import AdministracionHorarios from "../components/AdministracionHorarios/AdministracionHorarios";
import GestionOrdenes from "../components/GestionOrdenes/GestionOrdenes";
import formularioOverlay from "../components/formularioOverlay/formularioOverlay";
import sugerenciasTamanos from "../components/sugerenciasTamanos/sugerenciasTamanos";
import SubirArchivoV2 from "../components/SubirArchivoV2/SubirArchivoV2";
import MensajesNuevo from "../components/Mensajes/Mensajes";
import { consultarInformacionGeneralPacienteV2 } from '../apiService/request/CrudFormulario';
Vue.use(VueAwesomeSwiper);
Vue.use(VueMaterial);
Vue.use(VueCarousel);
Vue.use(Progress);
export default {
  data() {
    return {
      texto_introductorio: null,
      banderaSubirArchivo: false,
      textoGenerado: "",
      chatAbierto: true,
      flag: false,
      flagChat: false,
      VerReportes: false,
      estados_panel_lateral: 0,
      estado: "",
      iniciales: "",
      y: Number,
      usuarios: [],
      cedulaPaciente: "",
      mostrarListaPacientes: false,
      formularios: [],
      encuentro: [1],
      value: 0,
      VariablesFormulariosOn: false,
      nombre_campo: "",
      striped: true,
      textInside: true,
      obligatorio: Boolean,
      nombre: "",
      matriz_campo_llenado: [],
      nombre_campo_llenado: "",
      bandera_diligenciar: false,
      bandera_no_diligencio: false,
      slide_carrusel: [],
      matriz_mostrar_campos: [],
      matriz_mostrar_bordes: [],
      clase: "",
      matriz_informacion_general: [],
      accion: "",
      matriz_info_paciente: [],
      filtroUsuarios: "",
      usuariosInicial: [],
      mostrar_confirmacion: false,
      // urls
      endpointVariablesFormularios: "",
      endpointInformacionFormularios: "",
      endpointEvento: "", // endpoint encuentro
      matriz: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      numeroFormulariosDiligenciados: [],
      valueEncuentro: Number,
      iconoCopiar: "description",
      banderaCheckpoint: false,
      mostrarPopUp: false,
      topPopUp: Number,
      leftPopUp: Number,
      informacionFormulariosLlenos: [],
      formulariosMomentosllenos: [],
      banderaExpandir: false,
      paciente: {},
      datosMarcacionesPrograma: [],
      verComponente: "",
      overlay: false,
      tamanoHc: false,
      iconoGrafica:
        "M43,31.5c-0.6,0-1,0.4-1,1V42h-2.7v-6c0-0.6-0.4-1-1-1s-1,0.4-1,1v6h-2.7v-1.3c0-0.6-0.4-1-1-1s-1,0.4-1,1V42H30v-7.2c0-0.6-0.4-1-1-1s-1,0.4-1,1V42h-2.7V23.2c0-0.6-0.4-1-1-1s-1,0.4-1,1V42h-2.7V30.2c0-0.6-0.4-1-1-1s-1,0.4-1,1V42H16V27.8c0-0.6-0.4-1-1-1s-1,0.4-1,1V42h-2.7v-6c0-0.6-0.4-1-1-1s-1,0.4-1,1v6H6.7v-4.8c0-0.6-0.4-1-1-1s-1,0.4-1,1V42H2V17.1c4.3-0.2,6.7-2,8.9-3.7c2.3-1.7,4.4-3.3,8.7-3.3c4.3,0,6.5,1.6,8.7,3.3c2.3,1.7,4.6,3.4,8.9,3.7v3.7c0,0.4,0.2,0.8,0.6,0.9c0.1,0.1,0.3,0.1,0.4,0.1c0.3,0,0.5-0.1,0.7-0.3l4.7-4.7c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7L39,10.8c-0.3-0.3-0.7-0.4-1.1-0.2c-0.4,0.2-0.6,0.5-0.6,0.9v3.6c-3.7-0.2-5.7-1.7-7.7-3.3c-2.4-1.8-4.9-3.7-9.9-3.7s-7.5,1.9-9.9,3.7c-2.1,1.6-4.1,3-7.7,3.3V1c0-0.6-0.4-1-1-1S0,0.4,0,1v42c0,0.6,0.4,1,1,1h42c0.6,0,1-0.4,1-1V32.5C44,31.9,43.6,31.5,43,31.5zM39.3,13.9l2.3,2.3l-2.3,2.3V13.9z",
      verEncuentro:
        "M31.3,8.6h-4V8.1c0-0.6-0.4-1-1-1H25C24.6,5.9,23.4,5,22,5s-2.6,0.9-3,2.1h-1.3c-0.6,0-1,0.4-1,1v0.4h-4c-1.3,0-2.4,1.1-2.4,2.4v23.6c0,1.3,1.1,2.4,2.4,2.4h18.6c1.3,0,2.4-1.1,2.4-2.4V11C33.7,9.7,32.6,8.6,31.3,8.6z M28.9,13.4v18.7H15.1V13.4H28.9z M18.7,9.1h1.1c0.6,0,1-0.4,1-1C20.9,7.5,21.4,7,22,7s1.1,0.5,1.1,1.1c0,0.6,0.4,1,1,1h1.1v2.3h-6.6V9.1zM31.7,34.6c0,0.2-0.2,0.4-0.4,0.4H12.7c-0.2,0-0.4-0.2-0.4-0.4V11c0-0.2,0.2-0.4,0.4-0.4h4v0.9h-2.6c-0.6,0-1,0.4-1,1v20.7c0,0.6,0.4,1,1,1h15.7c0.6,0,1-0.4,1-1V12.4c0-0.6-0.4-1-1-1h-2.6v-0.9h4c0.2,0,0.4,0.2,0.4,0.4V34.6z M17,25.1h2.3v2.3c0,0.6,0.4,1,1,1h3.3c0.6,0,1-0.4,1-1v-2.3H27c0.6,0,1-0.4,1-1v-3.3c0-0.6-0.4-1-1-1h-2.3v-2.3c0-0.6-0.4-1-1-1h-3.3c-0.6,0-1,0.4-1,1v2.3H17c-0.6,0-1,0.4-1,1v3.3C16,24.6,16.4,25.1,17,25.1z M18,21.8h2.3c0.6,0,1-0.4,1-1v-2.3h1.3v2.3c0,0.6,0.4,1,1,1H26v1.3h-2.3c-0.6,0-1,0.4-1,1v2.3h-1.3v-2.3c0-0.6-0.4-1-1-1H18V21.8z M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,42C11,42,2,33,2,22S11,2,22,2s20,9,20,20S33,42,22,42z",
      marcacionesPrograma:
        //"M40.5,35.1v-5c0-4.4-3.6-8-8-8s-8,3.6-8,8V36c0,3.3-2.7,6-6,6s-6-2.7-6-6V25.3C18.4,24.8,23,19.8,23,13.8V3.3c0-0.6-0.4-1-1-1h-3.7V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v4.7c0,0.6,0.4,1,1,1s1-0.4,1-1V4.3H21v9.5c0,5.2-4.3,9.5-9.5,9.5S2,19.1,2,13.8V4.3h2.7v1.3c0,0.6,0.4,1,1,1s1-0.4,1-1V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v1.3H1c-0.6,0-1,0.4-1,1v10.5c0,6,4.6,10.9,10.5,11.4V36c0,4.4,3.6,8,8,8s8-3.6,8-8v-5.8c0-3.3,2.7-6,6-6s6,2.7,6,6v5c-2,0.5-3.5,2.2-3.5,4.4c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5C44,37.4,42.5,35.6,40.5,35.1z M39.5,42c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S40.9,42,39.5,42z",
        "M33.5,29.6v-2.7c0-2.9-2.3-5.2-5.2-5.2s-5.2,2.3-5.2,5.2v3.5c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2v-6.1c3.6-0.5,6.3-3.5,6.3-7.2v-6.3c0-0.6-0.4-1-1-1h-1.8V9.4c0-0.6-0.4-1-1-1s-1,0.4-1,1v2.8c0,0.6,0.4,1,1,1s1-0.4,1-1v-0.4H21v5.3c0,2.9-2.4,5.3-5.3,5.3s-5.3-2.4-5.3-5.3v-5.3h0.8v0.4c0,0.6,0.4,1,1,1s1-0.4,1-1V9.4c0-0.6-0.4-1-1-1s-1,0.4-1,1v0.4H9.4c-0.6,0-1,0.4-1,1v6.3c0,3.7,2.7,6.7,6.3,7.2v6.1c0,2.9,2.3,5.2,5.2,5.2s5.2-2.3,5.2-5.2v-3.5c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2v2.7c-1.2,0.4-2.1,1.6-2.1,2.9c0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1C35.6,31.1,34.7,30,33.5,29.6z M32.5,33.6c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1S33.1,33.6,32.5,33.6z M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,42C11,42,2,33,2,22S11,2,22,2s20,9,20,20S33,42,22,42z",
      iconoBot:
        "M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,2c8,0,14.9,4.7,18.1,11.5C36.1,7.7,29.4,4,22,4C14.6,4,7.9,7.7,3.9,13.5C7.1,6.7,14,2,22,2z M41.6,22C39.7,31.3,31.5,38,22,38S4.3,31.3,2.4,22C4.3,12.7,12.5,6,22,6S39.7,12.7,41.6,22z M22,42c-8,0-14.9-4.7-18.1-11.5C7.9,36.3,14.6,40,22,40c7.4,0,14.1-3.7,18.1-9.5C36.9,37.3,30,42,22,42z M13,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S16.3,16,13,16z M13,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S15.2,26,13,26z M31,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S34.3,16,31,16z M31,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S33.2,26,31,26z",
      flechaAbajo:
        "M22,24c-0.3,0-0.5-0.1-0.7-0.3l-21-22c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0L22,21.6L42.3,0.3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-21,22C22.5,23.9,22.3,24,22,24z",
      flechaArriba:
        "M43,24c-0.3,0-0.5-0.1-0.7-0.3L22,2.4L1.7,23.7c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4l21-22c0.4-0.4,1.1-0.4,1.4,0l21,22c0.4,0.4,0.4,1,0,1.4C43.5,23.9,43.2,24,43,24z",
      variablesInforGeneral:[]
    };
  },
  computed: {
    // Propiedad computada del paciente a partir de la información matriz_info_paciente
    pc_paciente() {
      let m_info_paciente = {};
      if (this.matriz_info_paciente) {
        // Recolectamos solo la información de nombre, apellido, documento y edad.
        this.matriz_info_paciente.forEach(data => {
          if (data.key && data.key == "nombre_paciente") {
            m_info_paciente.nombre = data.valor || "";
          } else if (data.key && data.key == "apellido") {
            m_info_paciente.apellido = data.valor || "";
          } else if (data.key && data.key == "documento") {
            m_info_paciente.documento = data.valor || 0;
          } else if (data.key && data.key == "edad") {
            m_info_paciente.edad = data.valor || 0;
          }
        });
      }
      return m_info_paciente;
    },
    cambiaPanelLateral() {
      try {
        switch (this.$store.getters.cambiaPanelLateral) {
          case "2":
            document.getElementById("lupaPacientes").disabled = true;
            break;
          default:
            document.getElementById("lupaPacientes").disabled = false;
            break;
        }
      } catch (err) {}
      return this.$store.getters.cambiaPanelLateral;
    },
    getReiniciar() {
      if (this.$store.getters.getReiniciar != null) {
        this.banderaCheckpoint = false;
        this.resetearCamposFormulario();
        // this.$store.dispatch("setId", null);
        this.$store.dispatch("setTextoGenerado", null);
        this.$store.dispatch("setFormularios", null);
        this.$store.dispatch("setCedulaPaciente", null);
        this.$store.dispatch("setReiniciar", null);
        this.$store.dispatch("setNombrePaciente", null);
        this.$store.dispatch("setIdFormulario", null);
      }
      return this.$store.getters.getReiniciar;
    },
    getOrdenesAutomaticasEncuentro() {
      console.log("holi", this.$store.getters.getOrdenesAutomaticasEncuentro);

      if (this.$store.getters.getOrdenesAutomaticasEncuentro) {
        this.generarOrdenesAutomaticas();
      }
      return this.$store.getters.getOrdenesAutomaticasEncuentro;
    },

    getCedulaPaciente() {
      if (
        this.$store.getters.getCedulaPaciente != null &&
        this.$store.getters.getCedulaPaciente != "si"
      ) {
        this.consultarInformacionGeneralPaciente(
          this.$store.getters.getCedulaPaciente
        );
      }
      return this.$store.getters.getCedulaPaciente;
    },
    getEncuentro() {
      if (this.$store.getters.getEncuentro != null) {
        this.consultarFormulario(this.$store.getters.getEncuentro);
        this.consultarMomentos(this.$store.getters.getEncuentro);
      }
      return this.$store.getters.getEncuentro;
    },
    getFormularios() {
      return this.$store.getters.getFormularios;
    },
    getConsultarFormulario() {
      if (
        this.$store.getters.getConsultarFormulario != null &&
        this.$store.getters.getIdFormulario != null
      ) {
        this.consultarVariablesFormulariosPanel2();
      }
      return this.$store.getters.getConsultarFormulario;
    },
    getNombreCampo() {
      if (this.$store.getters.getNombreCampo == "fin") {
        let self = this;
        setTimeout(function() {
          self.resetearCamposFormulario();
        }, 1500);
      }
      return this.$store.getters.getNombreCampo;
    },
    getFallback() {
      if (this.$store.getters.getFallback != null) {
      }
      return this.$store.getters.getFallback;
    },
    getCampoIngresado() {
      if (this.$store.getters.getCampoIngresado != null) {
      }
      return this.$store.getters.getCampoIngresado;
    },
    getInicioChat() {
      if (this.$store.getters.getInicioChat != null) {
        (this.matriz_informacion_general = []),
          (this.matriz_info_paciente = []);
        this.iconoCopiar = "description";
      }
      return this.$store.getters.getInicioChat;
    },
    getMomentosEncuentro() {
      if (this.$store.getters.getMomentosEncuentro != null) {
        this.iconoCopiar = "description";
        this.banderaCheckpoint = true;
      }
      return this.$store.getters.getMomentosEncuentro;
    },
    getMomentoActual() {
      if (this.$store.getters.getMomentoActual != null) {
      }
      return this.$store.getters.getMomentoActual;
    },
    getTextoGenerado() {
      if (this.$store.getters.getTextoGenerado != null) {
        this.textoGenerado = this.$store.getters.getTextoGenerado;
      }
      return this.$store.getters.getTextoGenerado;
    },
    getCheckpoint() {
      if (this.$store.getters.getCheckpoint == "si") {
        this.banderaCheckpoint = true;
        this.$store.dispatch("setCheckpoint", null);
      } else if (this.$store.getters.getCheckpoint == "no") {
        this.banderaCheckpoint = false;
        this.$store.dispatch("setCheckpoint", null);
        this.$store.dispatch("setMomentosEncuentro", null);
        this.$store.dispatch("setEncuentro", null);
        this.$store.dispatch("setVariablesFormularios", []);
        this.$store.dispatch("setNumeroCampo", null);
        this.$store.dispatch("setNombreFormulario", null);
        this.$store.dispatch("setCampoIngresado", null);
        this.$store.dispatch("setVariablesActualizadas", []);
        this.$store.dispatch("setCheckpoint", null);
        this.$store.dispatch("setMomentoActual", null);
      }
      return this.$store.getters.getCheckpoint;
    }
  },
  props: {
    valorSeleccionadoDialogo: {
      type: String
    }
  },
  watch: {
    getOrdenesAutomaticasEncuentro() {},
    getReiniciar() {},
    getCedulaPaciente() {},
    getEncuentro() {},
    getConsultarFormulario() {},
    getNombreCampo() {},
    getFallback() {},
    getCampoIngresado() {},
    getInicioChat() {},
    getMomentosEncuentro() {},
    getCheckpoint() {}
  },
  beforeUpdate() {
    console.log("overlay2:", this.overlay);
  },
  created() {
    this.matriz_campo_llenado = [];
    this.$store.dispatch("setOrdenesAutomaticasEncuentro", false);
    this.$store.dispatch("setMensajeChatBox", null);
    this.$store.dispatch("setCedulaPaciente", null);
    // this.$store.dispatch("setEncuentro", null);
    this.$store.dispatch("setFormularios", null);
    this.$store.dispatch("setNombreFormulario", null);
    this.$store.dispatch("setNombreCampo", null);
    this.$store.dispatch("setFallback", null);
    this.$store.dispatch("setCampoIngresado", null);
    this.$store.dispatch("setVerAgenda", null);
    this.$store.dispatch("setLogHistoriaClinica", null);
    this.$store.dispatch("setEspecificoHC", null);
    this.$store.dispatch("setNombreFormularioEspecifico", null);
    this.$store.dispatch("setResumenHC", null);
    this.$store.dispatch("setTipoCampo", null);
    // this.$store.dispatch("setMomentosEncuentro", null);
    this.$store.dispatch("setTextoGenerado", null);
    this.$store.dispatch("setVariablesFormularios", []);
    this.$store.dispatch("setCancelarFormulario", null);
    this.$store.dispatch("setFormulariosExistentes", null);
    this.$store.dispatch("setCheckpoint", null);
    this.$store.dispatch("setNumeroCampo", null);
    // this.$store.dispatch("setMomentoActual", null);
    this.$store.dispatch("setBanderaFormularioExistenteAbierto", false);
    this.$store.dispatch("setConsultarEncuentro", null);
    this.$store.dispatch("setestadoPanel", 0);
    // this.$store.dispatch("setId", null);
    this.$store.dispatch("setCargando", false);
    this.$store.dispatch("setTelefonoPaciente", null);
    this.$store.dispatch("cambiarEstadoModal", null);
    this.endpointVariablesFormularios =
      "/controlador_datos/historia_clinica/fs/formularios_variables";
    this.endpointInformacionFormularios =
      "/formularios_cuestionarios/formularios/api/v3/leer_resumen";
    this.endpointEvento =
      "/controlador_datos/historia_clinica/fs/formularios_encuentro";
    this.endpointActualizarResumen =
      "/controlador_datos/encuentros/api/v2/actualizar_resumen";

    // Permite obtener el valor del alto de las imagenes de los usuarios (aproximadamente el 4% del tamano total de la pantalla)
    this.y = screen.height * 0.041;
    //Recibe la lista de usuarios (desde el control panel) correspondiente a los filtros aplicados para ser visualizada en la barra lateral
    serverBus.$on("cargarListaDePacientes", listaUsuarios => {
      this.usuarios = listaUsuarios;
      this.usuariosInicial = listaUsuarios;
      this.filtroUsuarios = "";
    }),
      serverBus.$on("FormulariosMatriz", formularios => {
        this.formularios = formularios;
      });
    serverBus.$on("resetHistoriaClinica", mensaje_chat => {
      this.usuarios = [];
      this.usuariosInicial = [];
      this.filtroUsuarios = "";
    });
    serverBus.$on("mostrarListaPacientes", mostrar => {
      this.mostrarListaPacientes = mostrar;
    });
    serverBus.$on("mostrarListaPacientesDesdeControl", mostrar => {
      this.mostrarListaPacientes = true;
    });
    /**Cuando en las variables front del mensaje enviado desde el bot no exista la variable "nombre campo" no se mostrará el panel superior donde se incluye la barra
     * de progreso y las variables del formulario consultado (nombre_campo== 'undefined')*/
    serverBus.$on("NombreCampoIdefinido", bandera => {
      this.resetearCamposFormulario();
    });
    serverBus.$on("MostrarPopConfirmacion", () => {
      this.mostrar_confirmacion = true;
    });
    serverBus.$on("cerrarConfirmacion", () => {
      this.mostrar_confirmacion = false;
    });
  },
  beforeDestroy() {
    /**Se utiliza para apagar los serverbus cuando no se esten utilizando */
    serverBus.$off("cargarListaDePacientes");
    serverBus.$off("resetHistoriaClinica");
    serverBus.$off("mostrarListaPacientes");
    serverBus.$off("mostrarListaPacientesDesdeControl");
    serverBus.$off("informacionGeneralPaciente");
    serverBus.$off("ConsultarAgendaHC");
    serverBus.$off("NombreCampoIdefinido");
    serverBus.$off("verResumenFormulariosHC");
    serverBus.$off("MostrarPopConfirmacion");
  },
  mounted() {
    this.cambiarTamano();

    //Se obtiene el valor del alto de la barra de busqueda de paciente para redondear los borden de este componente cuando la barra lateral se encuentraa oculta
    try {
      let container = document.querySelector(".form");
      let x = container.offsetHeight;
      document.getElementById("form").style.width = x + "px";
    } catch (err) {}
  },
  beforeUpdate() {},
  components: {
    PanelAuxiliar,
    HeaderNav,
    ControlPanel,
    InformacionPaciente,
    Mensajes,
    Progress,
    Carousel,
    Slide,
    Agenda,
    VueAwesomeSwiper,
    ChatBoxNuevo,
    PopUp,
    verHistoriaClinica,
    Agendamiento,
    SeguimientoPaciente,
    Icono,
    graficaGestion,
    ConfirmarCita,
    AgendaDoctor,
    // AdministracionHorarios,
    GestionOrdenes,
    formularioOverlay,
    sugerenciasTamanos,
    SubirArchivoV2,
    MensajesNuevo
  },
  methods: {
    cambiarTamano() {
      const BORDER_SIZE = 3;
      let panel = document.getElementById("ColumnaDos");
      let resizeChatBox = document.getElementById("contenedorChatBox");
      let tamanoPantalla = screen.width / 2;
      let tamanoChatBox;
      let m_pos = 50;
      let resize = e => {
        this.dx = m_pos - e.x;
        m_pos = e.x;
        resizeChatBox.style.width =
          parseInt(getComputedStyle(resizeChatBox, "").width) - this.dx + "px";
        panel.style.width =
          // screen.width - resizeChatBox.style.width.replace("px", "") + "px";
          parseInt(getComputedStyle(panel, "").width) + this.dx + 0.7 + "px";
      };
      panel.addEventListener(
        "mousedown",
        e => {
          if (e.offsetX < BORDER_SIZE) {
            m_pos = e.x;
            document.addEventListener("mousemove", resize, false);
          }
        },
        false
      );

      document.addEventListener(
        "mouseup",
        function() {
          document.removeEventListener("mousemove", resize, false);
        },
        false
      );
    },
    cambiarTamanoHC() {
      let panel = document.getElementById("historiaClinicaDeslizar");
      if (this.$store.getters.getBarraArrastrar != null) {
        panel.style.width =
          parseInt(getComputedStyle(panel, "").width) -
          this.$store.getters.getBarraArrastrar +
          "px";
      } else {
        panel.style.width =
          parseInt(getComputedStyle(panel, "").width) -
          this.$store.getters.getBarraArrastrar * 5 +
          "px";
      }
    },
    async generarOrdenesAutomaticas() {
      try {
        const respuesta = await ordenesAutomaticas(
          this.$store.getters.getId,
          this.$store.state.provider_email,
          Number(this.$store.getters.getCedulaPaciente)
        );
      } finally {
        this.$store.dispatch("setOrdenesAutomaticasEncuentro", false);
      }
    },
    abrirChat() {
      this.chatAbierto = true;
      this.$router.push("/HistoriaClinica");
      this.tamanoHc = false;
    },
    verTimeLine() {
      this.$router.push("/HistoriaClinica/TimeLine");
      this.cerrarChat();
      this.tamanoHc = true;
    },
    async consultarMarcacionesProgramas() {
      try {
        const respuesta = await consultarMarcacionesProgramasPaciente(
          Number(this.$store.getters.getCedulaPaciente)
        );
        this.datosMarcacionesPrograma = respuesta.data.data;
        console.log("datos marcaciones", this.datosMarcacionesPrograma);

        //         if(!respuesta.data.data.length) {
        // this.datosMarcacionesPrograma = [0]
        //         } else {
        //           this.datosMarcacionesPrograma = respuesta.data.data;
        //         }
      } finally {
        this.verOverlayHC("marcacionesPrograma");
      }
    },
    verOverlayHC(componente) {
      this.verComponente = componente;
      this.overlay = true;
    },
    async verOverlayFormularioInformacionGeneral() {
      await this.crearCuestionarioInformacionGeneral(
        "informacion_general",
        "formularios"
      );
    },
    async crearCuestionarioInformacionGeneral(nombre_formulario, esquema) {
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await crearCuestionario(
          nombre_formulario,
          parseInt(this.$store.getters.getCedulaPaciente),
          this.$store.state.provider_email,
          null,
          null,
          esquema
        );
        console.log(respuesta.data.data.docId);
        this.$store.dispatch(
          "setIdFormularioInfoGeneral",
          respuesta.data.data.docId
        );
        // this.$store.dispatch("setBanderaFormularioCreadoPanel", true);
        this.consultarEsquemaCuestionarioInfoGeneral(
          respuesta.data.data.docId,
          esquema,
          "informacion_general"
        );
      } catch (err) {
        // this.$store.dispatch("setCargando", false);
      } finally {
        // this.$store.dispatch("setCargando", false);
      }
    },
    async consultarEsquemaCuestionarioInfoGeneral(
      formulario_id,
      esquema,
      tipo_esquema
    ) {
      try {
        const respuesta = await consultarEstructuraCuestionarioPorId(
          formulario_id,
          esquema,
          tipo_esquema
        );
        this.$store.dispatch(
          "setVariablesFormulariosInfoGeneral",
          respuesta.data.data.variables
        );
        this.$store.dispatch(
          "setNombreFormularioInfoGeneral",
          respuesta.data.data.nombre? respuesta.data.data.nombre : respuesta.data.data.key,
        );
        this.$store.dispatch(
          "setColeccionInfoGeneral",
          respuesta.data.data.coleccion
        );
      } finally {
        this.$store.dispatch("setCargando", false);
        this.verComponente = "verFormulario";
        this.overlay = true;
        console.log("overlay:", this.overlay);
      }
    },
    cerrarOverlay(valor) {
      this.overlay = valor;
      this.datosMarcacionesPrograma = [];
    },
    cerrarOverlaySinActualizar() {
      this.overlay = false;
      this.datosMarcacionesPrograma = [];
    },
    cerrarChat() {
      this.chatAbierto = false;
    },
    expandirPanel: function() {
      this.banderaExpandir = !this.banderaExpandir;
    },
    verCategoriaFormulario: function(nombreCategoria) {
      if (this.verCategoria == nombreCategoria) {
        this.verCategoria = "";
      } else {
        this.verCategoria = nombreCategoria;
      }
    },
    enviaMomentoChat: function(nombreMomento, momento) {
      this.$store.dispatch("setMensajeChatBox", nombreMomento);
      this.$store.dispatch("setBanderaFormularioExistenteAbierto", false);
      serverBus.$emit("parametrosFormulariosMomentosllenos", momento);
    },
    posicionPopUp: function(indice) {
      const coordenadasDiv = document
        .querySelector("#avatar" + indice)
        .getBoundingClientRect();
      const coordenadasLeft =
        coordenadasDiv.left - 1 < 1320
          ? (this.coordenadasLeft = coordenadasDiv.left - 640)
          : (this.coordenadasLeft = coordenadasDiv.left - 880);
      const coordenadasTop = coordenadasDiv.bottom - 70;
      this.mostrarPopUp = true;
      const respuesta = {
        coordenadasLeft: this.coordenadasLeft,
        coordenadasTop: coordenadasTop
      };
      return respuesta;
    },
    async asignarPosicionPopUP(indice, momento) {
      const respuesta = await this.posicionPopUp(indice);
      this.consultarInformacionMomentos(momento);
      this.leftPopUp = respuesta.coordenadasLeft + "px";
      this.topPopUp = respuesta.coordenadasTop + "px";
    },
    async consultarInformacionMomentos(momento) {
      this.informacionFormulariosLlenos = [];
      const respuesta = await consultarInformacionMomentoLlenos(
        this.$store.getters.getId,
        momento
      );
      this.informacionFormulariosLlenos = respuesta.data.data;
    },
    cerrarPopUp: function() {
      this.mostrarPopUp = false;
    },
    actualizarResumen: function() {
      let endpoint;
      let json = {};
      json["encuentro_id"] = this.$store.getters.getId;
      json["resumen"] = this.textoGenerado;
      endpoint = this.endpointActualizarResumen;
      axios
        .patch(endpoint, json)
        .then(Response => {
          this.$store.dispatch("cambiarEstadoModal", true);
          this.$store.dispatch("cambiarMensajeModal", Response);
          this.$store.dispatch("setTextoGenerado", null);
        })
        .catch();
    },
    copiarAlPortapapeles(id_elemento) {
      var copyTextarea = document.querySelector(".js-copytextarea");
      copyTextarea.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        this.iconoCopiar = "check_circle_outline";
      } catch (err) {}
    },
    consultarMomentos(momento) {
      axios
        .get("/controlador_datos/encuentros/api/v2/consultar_momentos", {
          params: {
            encuentro: momento
          }
        })
        .then(Response => {
          this.$store.dispatch("setMomentosEncuentro", Response.data.data);
        });
    },
    setDone(id, index, indiceMatriz) {
      this[id] = true;
      if (index) {
        this.active = index;
        let matrizMomentos = this.$store.getters.getMomentosEncuentro;
        matrizMomentos[indiceMatriz].estado = true;
        this.$store.dispatch("setMomentosEncuentro", matrizMomentos);
        if (indiceMatriz == 4) {
          this.$refs.mySwiper.swiper.activeIndex = 1;
        }
      }
      // let prueba= mySwiper.width
    },

    /**Esta función realiza la consulta al endpoint de formulario y permite visualizar en la HC los formularios asociados a un evento
     * @param {*} encuentro este parametro viene de la respuesta del bot
     */
    consultarFormulario: function(encuentro) {
      let endpoint;
      let json = {};
      json["encuentro"] = encuentro;
      endpoint = this.endpointEvento;
      axios
        .post(endpoint, json)
        .then(res => {
          if (res.data && res.data.data) {
            this.$store.dispatch("setFormularios", res.data.data);
          }
        })
        .catch();
    },
    /**Este metodo activa la bandera de VerReportes para que dicho modulo se muestre en la historia clinica */
    Reporte: function() {
      this.VerReportes = true;
    },
    /** Metodo para obtener infomacion de eventos 
        del paciente */
    obtenerInfoPaciente: function(cedula) {
      /** Variable utilizada para indicar que se selecciono un paciente
            se mostrara informacion basica del paciente. */
      this.estado = "info_paciente";
      this.VerReportes = false;
      this.cedulaPaciente = cedula;
      this.filtroUsuarios = this.cedulaPaciente;
      // Si solo hay un paciente en la lista o ninguno, no necesita filtrar
      if (this.usuarios.length != 1 && this.usuarios.length != 0) {
        this.filtraListaUsuarios(this.cedulaPaciente);
      }
      /** Se emite comando para realizar nuevamente la consulta del paciente */
      this.$store.dispatch(
        "setMensajeChatBox",
        "Enviar mensaje a los pacientes seleccionados"
      );
      // serverBus.$emit('lista_pacientes_chat', (lista_pacientes))
    },
    async consultarVariablesFormulariosPanel2() {
      try {
        if(this.$store.getters.getIdFormulario && this.$store.getters.getNombreFormulario) {
          const respuesta = await consultarEstructuraCuestionarioPorId(
            this.$store.getters.getIdFormulario,
            this.$store.getters.getColeccion,
            this.$store.getters.getNombreFormulario
          );
          if (respuesta &&
            respuesta.data &&
            respuesta.data.data &&
            respuesta.data.data.texto_introductorio) {
            this.texto_introductorio = respuesta.data.data.texto_introductorio;
          } else {
            this.texto_introductorio = null;
          }
          // const respuesta = await consultarEstructuraCuestionarioPorId(
          //   'Tzq2s29h0T6rSajaFOkh',
          //   "formularios",
          //   "factor_de_tabaquismo"
          // );
          this.$store.dispatch(
            "setVariablesFormularios",
            respuesta.data.data.variables
          );
          this.$store.dispatch("setNombreFormulario", respuesta.data.data.key);
          this.$store.dispatch("setColeccion", respuesta.data.data.coleccion);
          if (
            respuesta &&
            respuesta.data &&
            respuesta.data.data &&
            respuesta.data.data.formularioSerie
          ) {
            this.$store.dispatch("setSerieFormularios", []);
            this.$store.dispatch(
              "setEsquemaFormularioSerie",
              JSON.parse(
                JSON.stringify({
                  variables: respuesta.data.data.variables
                })
              )
            );
            this.$root.$emit('formularioSerie', true);
          }
          this.value = 0;
          this.VariablesFormulariosOn = true;
        }
      } catch (err) {}
    },
    consultarInformacionGeneralPaciente: function(documento) {
      let endpoint;
      let json = {};
      json["documento"] = documento;
      json["tipo_esquema"] = "resumen paciente";
      endpoint = this.endpointInformacionFormularios;
      axios
        .post(endpoint, json)
        .then(async res => {
          if (res.data && res.data.data && res.data.data.variables) {
            this.matriz_info_paciente = res.data.data.variables;
            await this.infoGeneralPatient();
          }
        })
        .catch();
    },
    async infoGeneralPatient() {
      try {
        let respuesta = await consultarInformacionGeneralPacienteV2(
          this.$store.getters.getCedulaPaciente,
          "informacion_general",
          null
        );
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.variablesInforGeneral = respuesta.data.data.variables;
        }
      } catch (error) {
        console.log(error);
      }
    },
    resetearCamposFormulario: function() {
      (this.bandera_diligenciar = false),
        (this.bandera_no_diligencio = false),
        (this.value = 0),
        (this.VariablesFormularios = []),
        (this.VariablesFormularios_nombre = []),
        (this.VariablesFormulariosOn = false),
        (this.formularios = []);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/sass/main.scss";
.padre {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
}
.swiper-pagination >>> .swiper-pagination-bullet {
  opacity: 1;
  border: #999 solid 1px;
  background-color: #cccccc;
}
.swiper-pagination >>> .swiper-pagination-bullet-active {
  background-color: #33ccff;
}
.swiper-button-prev {
  opacity: 1;
  top: 50%;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAFxAAABcQBm3m1AAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAATSSURBVHic7ZxNb9s2GMf/YUgU2bFtXtb02PRlTbPuvMNgZ2t22KeQD0acr2NDcRTrWywvhV8GZNde2kOc7byuQAr0lqAwxewgGuAUyY0diSJV/YAc7IQR8cfzs2TqEYGSkpKSkpKSkplptVornuct53FsksdB08TzvIeU0hMhxInruqu6jz+n+4Bp4nneQyHEAMAj+dbfQojK9vb2P7rmYG0Fep63LIR4jTC8U/mzRgg5cl13Sdc8rAzQdd1VIcSfAJ4BeBMEwY+MsZ8AvAOwTgg56XQ6D3TMxboAXdddJYSMtX0TBMEvjUbjk+M454yxTYQhPuacD3SEaFWAnuctE0JeA1gDcMo5/63RaHza29sb7O7u9hzHOQewBWCIMMSDdrt9P8s5WROg/MzrA/gOYXjVnZ2dDwBwdXVF5+bmKADU6/V/AVQBnAH4HkC32Wzey2peVpyFFW3XALwFsFmv1z9OGuP7/uJoNOoBeIGwIqsy3FQxvgJjtN2q1+sfx9omjbu4uBAAAvkys0KhWf3jNJDa9pCsrYgb12w27zHGugBeIlS5kkX1AQYrHNWWMfazPElMpN1ufwugD+ApgHeMsc2bjJsVIxV2XXeJEHIMRVvHcc6/pK08WRwgDO8MwFaW4QEGKizD6wF4DmBoorYqRinc6XQecM7/gOHaqhijsOu6S5zzsbZDk7VVMSJA3/cXpbbrCMOrxF0kR8lLW5XcFZbaDgA8xhT65amtSq4V6Pv+Iuf8CGF4Q875Kxu0VcntLBz3Vcvks20SuShsu7Yq2hWOagupn03aqmhVWGrbRcwKiU3aqmhTWGrbB/AElmurokXhdrt9n3N+iDA867VVyVxhuaTeBbCBgmirkqnCUr8BCqatSmYKy8orpLYqmSgsQ+givKlTOG1VUlf4a9BWJVWFFf2eQNGvaNqqpKbwJP2Kpq1KKgrPqp+t2qrcWuEk/YqsrcqtA1xYWLgDYEG+vJifn/8MTF5JnjTONlJReNY2Cl3tF1mS2mXM1xpiapcxjuOcU0p/Rfh59hTAwaSuKLUlLTLu9/39/btpzStrUr0OrNVq7yml49ayl4yxxNYy9TMyMu6HIAi6toSYyWJCRMsbX9vZqHMmiwlKp+gZwm8lh0XVObPVGFk5FchOUcZYL6nd1madM1/SL7rOmS/px+k8qfHbNp213BOJ6gygMDprvbEe1ZlSWq3Vau+nHGeUzlpvrEd15pwf+r6/mPT3NuisvTMhovPGaDTqJoVog865tbdFtPyLUlqxUefc2ttiHss6slHnXPsDlceyhgBejEajnm06596hCtitsxE90jE6H096aNoknY0IELim8zohpJcUokk6G6GwSlRnIUT1Jnsg5KWzMRU4Jqrzl/ZAyFtn4wIEYnXum6qzcQqrRLS88ZYmOnU2sgLHRHReI4QcT9qhKA+djQ4QuKbzcyFEPylEVefLy8vPAC7lr74JguBOFvMzWmGVaXSetaF9FoyvwDHKvjBvEeo8iNsrS2d4gEUVOEZ51mQDkUqU2wT0MeUTULfBugCB6yESQqoAIPeVmeph7dtiZYBAuGcgpXSA8Cx7Kt9+hsjzxlljbYDAtUoENFbeGKsDBP4XInSHVxhardZKq9VayXseJSUlJSUlJTr5D9uTZIwWl0I/AAAAAElFTkSuQmCC");
}
.swiper-button-next {
  opacity: 1;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAFxAAABcQBm3m1AAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAATOSURBVHic7ZzBUttGHIc/NNJk6LEJkJIcegikJU2bvkCLnTbpc4gDA34dGGGE/RYNIWObzuTcS3LANOemmeHQW5lWa9GD1u3GBWrLu6uVo2+GGcxo0c6P/6cVq9VCRUVFRUVFxQfA7u7u7d3d3dtF90Mnc7ZOFEXRHc/zfgJI03R9a2vrV1vnNoln4yQyvGPgHnDP87zjKIru2Di3aYwHGEXRoud5R8AKcCK/VjzPexHH8ZLp85vGaICtVmvZ87yXwAPgFfBNEATfyu/X0jR9WfZKNHYNbLVay0KIY2AVeB0EweMwDM8A2u32QpIkHeBL4E2aprWyXhONVGCz2bwlhDgkC68vhHgShuHZ/v7+8d7eXjcMwzMhxFOgT8l11h7gzs7OTWBYXX2g3mg03gFcXFz4c3NzPkCj0XgnhKjJY9bSNO2WMUStCjebzU+AY+A+I9pehdS5CzykhDprrUDf99U/iEjTdHDVsSM6P+FfnY+iKFrU2S+TaA1wY2Pjre/7deAU+HowGHQODg4+vuzYa3R+4HletywhGhmFR7TsA/XNzc3fJmz3xvf99Y2Njbcm+qgLI6NwGIZnvu//QFaJnwE/XlWJ8L7OwD+jsxDCeZ2N3Ujn1VlWap0sxC88z+u22+0FU/2cFuOTCZp0/sX3/ZqLOhv/X1iTzqtCiOcuVqKV2RhNOj9MksQ5na3NB8Js6mylAofMos5WA4TZ09mqwiqadD71fb9epM7WK3CIJp3vCyEOm83mLTu9/i+FBQhadD4lmzbrFhViYQqrlFnnQitwiAadT8l0fma7Ep0IEKbWuSbbfQV0bIbohMIqunQGauO0mxZnKnCILp2BZ/L5jFGcCxC06fwoCIKO6RCdU1ilDDo7WYFDptFZaWdUZ6cDhPw6j7QzprPTCqto0nnsduPifAUO0aTz/7ablNIECHB+fv4ncC4/fjQYDG5cdayq8yTtJqU0CstlIz2yKhpr2cg07calFAG6Gh6UQGE5cj4jC+EUeKoulZu0ne7++bp/oU52dnZuBkHQAR4xckMsr3HpNe26ZJML2kdeFWcVnlLbiZbYTYOTCufVVk5jHZKF18eQtirOKZxXWxleBwvaqjilcF5t5YL2Hpa0VXFG4Wm0lQvarWmr4kSAY2h76aVGPljvoixot6GtSuEKl1FblUIrMK+27XZ7QQjxnIK0VSlsFM472pqenpqUQhSeUttLXx8rCusKa9B2lYK1VbEaYN7RNoqixSRJekhthRBWnvmOgzWFZ0lbFSsVmFfbKIoWhRBHjLz1aaPP42J8FM472so33XtkL2v3hRC14VufLmFU4bzaKnssrACvgiD4zrXKG2JM4bzaxnG8pOyx0BdCODHaXoURhfNqG8fxUpqmXTJtT4QQdRe1VdGu8IegrYpWhafU9gVyaxTXtVXRGuD8/PwNYF5+/CNJkr/g+ptkqW0PWKMk2qpoV3iShd9l1VZF+ygchuFZEASPgddkC797rVZrefS4OI7vlj08MPjG+kiI7+2VFcfx3TRNh+H9PBgM1ssYHhi+kb5sSxMgkJX3KVl4329vb/9ush8mMT6ZMHJbcyJ//DklHDAuw8pszMheWTADlTfE2nSWEmIyK+FZZxa3AK2oqKioqKgoir8B4ydxNapJZ0AAAAAASUVORK5CYII=");
}
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  top: 85%;
}
.swiper-container {
  height: 65%;
  margin-top: 5%;
  margin-left: auto;
  margin-right: auto;
}
.swiper-slide {
  height: 50%;
}
#botonBuscarPaciente {
  border: none;
  background: white;
  height: 100%;
  width: 100%;
}
button:focus {
  outline: 0;
}
control-panel {
  width: 40%;
  height: 40%;
  overflow: auto;
}
#Icono {
  vertical-align: top;
  height: 90%;
  width: 90%;
}
#Chat {
  height: 85%;
  width: 100%;
}
#NombreUsuario {
  font-family: "Nunito", sans-serif;
  font-size: 1vw;
  color: #999;
  margin: 0%;
  font-weight: bold;
  width: 70%;
  transition: 0.5s;
}
#InfoUsuario {
  display: inline-flex;
  justify-content: space-around;
  align-items: center;
  width: 80%;
  height: 5%;
  margin: 3% 10% 3% 10%;
  transition: 0.6s;
}
#ImgUsuarios {
  border-radius: 50%;
  border: 1px solid #999;
  display: flex;
  justify-content: center;
  vertical-align: center;
}
#DivNombre {
  display: flex;
  justify-content: center;
  vertical-align: center;
}
#GridBotones {
  height: 100%;
}
#GridBotones div img {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
#GridBotonesShow div img {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
#GridBotonesShow {
  display: grid;
  height: 100%;
  width: 100%;
  justify-content: center;
  vertical-align: center;
  grid-template-columns: 50% 50%;
  grid-template-rows: 30% 30% 30%;
  grid-gap: 5% 3%;
  grid-template-areas: ". .";
}
#Grid {
  display: flex;
  height: 100%;
  max-width: 1920px;
  margin: auto;
}
.ColumnaUno {
  width:35%;
  min-width:30%;
  max-width: 50%;
  // width: 40%;
  // min-width: 40%;
  // height: 100%;
  // transition: all cubic-bezier(0.04, 0.18, 0.79, 1.02) 0.4s;
  // @extend .scrollbar;
  // width: 100%;
  // padding: 0 15px;
  // overflow: auto;
  position: relative;
  padding-left: 4px;
  height: 100%;
  left: 0;
  background-color: #f0f0ff;
  // transition: all cubic-bezier(0.04, 0.18, 0.79, 1.02) 0.2s;
}
.resizeColumnaDos {
  width: 100%;
  // padding: 0 15px;
  // overflow: auto;
  position: relative;
  padding-left: 4px;
  height: 100%;
  &:after {
    content: " ";
    background-color: #ccc;
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    cursor: w-resize;
  }
}
#ColumnaDos {
  // width: calc(100vw - 41%);
  width: 60%;
  height: 100%;
}
#Grid > div {
  border-bottom: 1px solid #ccc;
}
.expandirItem2 {
  width: 100% !important;
  max-width: 100%;

  .item2Comprimido,
  .item2Expandido {
    width: 100% !important;
    max-width: 100%;
    padding: 25px;
  }
}
.item2Comprimido {
  max-width: 100%;
  height: 87%;
  overflow-x: hidden;
  padding: 25px;
  padding-bottom: 80px;
}
.item2Expandido {
  width: 100%;
  height: 77%;
  overflow: hidden;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 25px;
  padding-bottom: 80px;
}
.item1Comprimido {
  display: inline-flex;
  align-items: center;
  border-bottom: 1px solid $gris-plata;
  width: 100%;
  height: auto;
  transition: all 0.4s;
  background-image: url(https://firebasestorage.googleapis.com/v0/b/neumomeddesarrollo.appspot.com/o/fondo-para-historia-clinica.png?alt=media&token=3d4da308-f19e-4974-a126-22a133ebd665);
  background-size: cover;
  padding: 5px 0px 5px 25px;
}
.item1Expandido {
  display: inline-flex;
  align-items: center;
  border-bottom: 1px solid $gris-plata;
  width: 100%;
  height: calc(100vh - 80%);
  transition: all 0.4s;
  background-image: url(https://firebasestorage.googleapis.com/v0/b/neumomeddesarrollo.appspot.com/o/fondo-para-historia-clinica.png?alt=media&token=3d4da308-f19e-4974-a126-22a133ebd665);
  background-size: cover;
  padding: 5px 0px 5px 25px;
  // max-height: 220px;
  max-height: 190px;
}

.item3 {
  padding: none;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  border-right: 2px solid $gris-plata;
  // transition: all cubic-bezier(0.04, 0.18, 0.79, 1.02) 0.09s;
}
// cambia el tamaño del item para tener transicion
.reducirItem3 {
  width: 0 !important;
  min-width: 0 !important;
  .item3 {
    width: 0;
    min-width: 0;
  }
}
.informacionCompleta {
  display: flex;
  margin: 1% auto 2% 0%;
  max-height: 75px;
  .col {
    padding: 0;
  }
}
.nombreBot,
.nombrePaciente,
.apellidoPaciente {
  // font-size: 28px;
  font-size: 24px;
  font-weight: 700;
  color: #00000099;
  // color: #3A5FBA;
  margin: auto 0;
  display: inline;
}
.nombrePaciente {
  margin: 0 auto -14px 0;
  display: flex;
  justify-content: flex-start;
  padding: 0 5px 10px 0;
  // max-width: fit-content;
  min-width: max-content;
  h3 {
    font-size: 24px;
    font-weight: 700;
    color: #00000099;
  }
}
.nombreCompleto {
  height: max-content;
  display: flex;
  flex-wrap: wrap;
  // background: white; comentado por el momento mientras se busca como arreglar la tarjeta
  // width: 320px;
  // border-radius: 25px;
  // justify-content: center;
  // padding-left: 16px;
  .agenda {
    &:hover {
      cursor: pointer;
    }
  }
  .col-6 {
    padding: 0 0 7px 0;
    max-width: max-content;
    // max-width: 149px;
  }
  .col-12 {
    padding: 0;
  }
}
.imagenPerfil {
  height: 55px;
  width: 55px;
  max-height: 75px;
  margin-right: 30px;
}
.contenedorImagenGestion {
  color: #3a5fba;
  padding: 7px;
  border-radius: 100%;
  margin-right: 15px;
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4f5f8;
  position: absolute;
  left: 0;
  top: -8px;
}
.imagenGestion {
  height: 30px;
  width: 30px;
  max-height: 75px;
  margin-right: 0px;
}
.bordeGestion {
  box-shadow: 0 3px 3px -2px rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.14),
    0 1px 8px 0 rgba(0, 0, 0, 0.12) !important;
  border-radius: 26px;
  padding-right: 15px;
  background-color: white;
  height: 40px;
  position: relative;
  width: 175px;
  padding-left: 65px;
}
.perfil-info-general {
  &:hover {
    cursor: pointer;
  }
}
.flechaExpandir {
  margin: auto 2% 1% auto;
  color: #646a6f;
  display: flex;
}
.iconosOverlay {
  padding: 2px;
  margin: 2px;
  display: inline-flex;
  float: left;
}
.contenidoMarcaciones {
  border-radius: 50% !important;
}
#IzquierdaPaciente {
  display: inline-flex;
  height: 100%;
  min-width: 70%;
}
.item2 {
  height: 100%;
  width: 100%;
}
#Informacion {
  width: 100%;
  height: 100%;
  margin-left: 5%;
  transition: 0.8s;
}
#InformacionGeneral {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
}
.botonCircularMediano {
  position: absolute;
  bottom: 10px;
  left: 20px;
  background-color: white !important;
  z-index: 500;
}
.botonCircularMediano:hover {
  background-color: $gris-plata-clarito !important;
  color: $gris;
}
// .botonAbrirChat {
//   @extend %iconoElevado;
//   box-shadow: $elevacion-8 !important;
//   height: 3.75vw !important;
//   width: 3.75vw !important;
//   position: absolute;
//   bottom: 1.667vw;
//   left: 1.25vw;
//   background-color: white !important;
//   z-index: 500;
//   &:hover {
//     box-shadow: $elevacion-12 !important;
//   }
//   &:active {
//     background-color: white !important;
//     box-shadow: $elevacion-4 !important;
//   }
// }
#Principal {
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  color: #9aa4ac;
  margin: 0%;
  padding-top: 1%;
  font-weight: 500;
}
.fade-enter-active {
  transition: all 1.8s;
}
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#ChatBox {
  margin: 0%;
  border-top: 1px solid #ccc;
  width: 100%;
}
#lineaStep {
  width: 100%;
  border-bottom: 2px solid #999;
}
::placeholder {
  color: #ccc;
  font-size: 1.2vw;
  opacity: 1;
  transition: 0.8s;
}
.form-control-borderless {
  border: none;
  width: 100%;
  height: 100%;
  font-family: "Nunito", sans-serif;
  color: #ccc;
  font-style: italic;
  box-shadow: none;
}
.form-control-borderless:focus {
  border: none;
  outline: none;
  box-shadow: none;
}
#main {
  height: calc(100vh - 10%);
  transition: margin-left 0.5s;
}
.momentoActual {
  margin: auto;
  min-width: 80px;
}
.momentos {
  min-width: 64px;
}
.momentoAct {
  object-fit: none;
  transition: 0.3s;
}
.momentoActIcono {
  width: 2.5vw;
  height: 4.444vh;
}
.momento {
  object-fit: contain;
  transition: 0.3s;
  height: 2.963vh;
}
.textoDatosPaciente {
  // margin-top: 10px;
  font-size: 14px;
  font-weight: 600;
  min-width: 1400px;
  line-height: 1;
}
.colorDatosPaciente {
  color: #646a6f;
}
.panelLateral {
  display: flex;
  justify-content: center;
  width: 90%;
  margin: auto;
  margin-top: 3%;
  margin-bottom: 2%;
}
.divAvatar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}
.divTextoGenerado {
  margin: 5%;
  label {
    @extend %titulo-componente;
  }
}
.botonTextoGenerado {
  @extend %textoElevado;
  font-size: 15px !important;
}
.botonTextoGenerado:hover {
  background-color: #e3e3e7bb !important;
}
.contenedorCopiar {
  display: flex;
  justify-content: flex-end;
}
.btnCopiar {
  @extend %iconoElevado;
  margin-left: 3%;
}
.btnCopiar::before {
  background-color: transparent;
}
.textArea {
  @extend %texto;
}
.botonCircularPequeno {
  margin-left: 10px;
  .iconoFlecha {
    margin-top: 8px;
    height: 20px;
    width: 20px;
  }
}
.invisible {
  display: none;
}
/* garantiza que no se salga el texto con la informacion del paciente del contenedor */
// @media only screen and (max-width: 1666px) {
//   .item1Expandido {
//     height: calc(100vh - 87%);
//   }
// }
@media only screen and (max-height: 695px) {
  .item1Expandido {
    // height: 23vh;
    // height: calc(100vh - 88%);
    height: 170px;
  }
}
// @media only screen and (max-height: 687px){
//     .item1Expandido {
//     // height: 23vh;
//     // height: calc(100vh - 76%);
//     height: 180px;
//   }
// }
@include pantalla-mediana {
  #main {
    // height: 625px;
    min-height: 92%;
  }
  .imagenPerfil {
    max-height: 55px;
  }
  .nombreBot,
  .nombrePaciente,
  .apellidoPaciente {
    font-size: 23px;
    line-height: 35px;
  }
  h4 {
    font-size: 19px;
  }
  #Principal {
    font-size: 14px;
  }
  .nombreBot,
  .nombrePaciente,
  .apellidoPaciente {
    font-size: 23px;
  }
  .bordeGestion {
    height: 35px;
  }
  .contenedorImagenGestion {
    height: 45px;
    width: 45px;
    top: -5px;
  }
  .momentoActual {
    margin: auto;
    min-width: 64px;
    min-height: 64px;
  }
  .momentos {
    min-width: 48px;
    min-height: 48px;
  }
  #btnIconoExpandir {
    margin-right: 10px;
  }

  .item1Expandido {
    // height: 23vh;
    max-height: 162px;
  }
  .item2Expandido {
    padding-bottom: 100px;
  }
  .item2Comprimido {
    padding-bottom: 60px;
  }
  .textoDatosPaciente {
    font-size: 12px !important;
  }
  .botonCircularPequeno {
    .iconoFlecha {
      margin-top: 7px;
      height: 17px;
      width: 17px;
    }
  }
}
@include pantalla-pequena {
  // .item1Expandido {
  //   height: 23%;
  // }
  #ColumnaDos {
    width: calc(100vw - 42%);
  }
  .imagenPerfil {
    max-height: 55px;
  }
  //   .item1Expandido {
  //   // height: 23vh;
  //   height: calc(100vh - 85%);
  // }
  .bordeGestion {
    height: 35px;
  }
  .contenedorImagenGestion {
    height: 35px;
    width: 35px;
  }
  .nombreBot,
  .nombrePaciente,
  .apellidoPaciente {
    line-height: 38px;
    font-size: 19px;
  }
  .botonCircularPequeno {
    .iconoFlecha {
      margin-top: 5px;
      height: 14px;
      width: 14px;
    }
  }
  @include pantalla-celular {
    .item1Expandido {
      max-height: 160px;
    }
  }
}
</style>
<style lang="scss">
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s ease;
}
// .slide-fade-enter, .slide-fade-leave-to
// /* .slide-fade-leave-active below version 2.1.8 */ {
//   transform: translateX(10px);
//   opacity: 0;
// }
@import "~vue-material/dist/theme/engine"; // Import the theme engine
@include md-register-theme(
  "default",
  (
    primary: #999999,
    // The primary color of your brand
      accent: #999999,
    // The secondary color of your brand
      theme: light
  )
);
// @import "~vue-material/dist/components/MdField/theme"
@import "~vue-material/dist/theme/all";
.iconoBotonCopiar {
  margin: 5%;
}
</style>


// WEBPACK FOOTER //
// src/components/HistoriaClinica.vue